import React from "react";
import { Translate } from "react-localize-redux";


const ITradeChartLegend = ({ data, currency }) => {
    return (
        <React.Fragment>
            <div className="columns is-mobile" style={{ justifyContent: "center", fontSize: "0.8em",  alignItems: "center" }}>
               <span className="column is-narrow"><Translate id="Report.Itrade.BandValues" data={{ currency: currency }} />:</span>
            <div className="column" style={{ justifyContent: "center" }}>
                <div className="columns">
                    {data.map((d, i) =>
                        <div className="column is-is-one-fifth is-inline-flex" key={i} style={{ flexBasis: "15%", textAlign: "center", alignItems: "center" }}>
                            <div className="is-inline-block" style={{ backgroundColor: getColor(i), marginRight: "5px", width: "20px", height: "0.8em"}}></div>
                            {d.range}
                        </div>
                    )}
                </div>
                </div>
            </div>
        </React.Fragment>

    )
}
const getColor = (i) => {
    if (i === 4)
        return "#a0d406";
    if (i === 3)
        return "#f4af24";
    if (i === 2)
        return "#e7445e";
    if (i === 1)
        return "#ae7199";
    if (i === 0)
        return "#61b4e4";
}

export default ITradeChartLegend;